module.exports = __webpack_public_path__ + "img/ic-contact-line.b312016f.png";